import React, { useMemo, useState } from "react";
import "./CancellationRefundPolicy.css";

/* Accordion */
function AccItem({ title, icon, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`crAccItem ${open ? "open" : ""}`}>
      <button
        className="crAccHeader"
        onClick={() => setOpen(v => !v)}
        aria-expanded={open}
        type="button"
      >
        <span className="crAccIcon">{icon}</span>
        <span className="crAccTitle">{title}</span>
        <span className="crAccChevron">{open ? "–" : "+"}</span>
      </button>

      <div className="crAccBody" style={{ display: open ? "block" : "none" }}>
        {children}
      </div>
    </div>
  );
}

export default function CancellationRefundPolicy() {
  const highlights = useMemo(() => [
    { top: "No Refunds", bottom: "After Order Confirmation" },
    { top: "Re-dispatch ₹49", bottom: "If Returned by Customer Issue" },
    { top: "Unboxing Video", bottom: "Mandatory for Claims" },
    { top: "Delhivery", bottom: "Shipping Partner" },
  ], []);

  return (
    <div className="crPage">
      <div className="crWrap">

        {/* HERO */}
        <div className="crHero">
          <h1 className="crTitle">
            Cancellation, Refund & Delivery Policy
          </h1>

          <p className="crSub">
            At Ayrine, every order is carefully packed and verified.
            Please review our strict no-refund and delivery terms before placing your order.
          </p>

          <div className="crChips">
            {highlights.map(h => (
              <div key={h.bottom} className="crChip">
                <span className="crChipTop">{h.top}</span>
                <span className="crChipText">{h.bottom}</span>
              </div>
            ))}
          </div>
        </div>

        {/* GRID */}
        <div className="crGrid">

          {/* LEFT — IMPORTANT NOTICE */}
          <div className="crCard">
            <h2 className="crCardTitle">Important Policy Notes</h2>

            <div className="crAlert danger">
              <div className="crAlertTitle">Strict No-Refund Policy</div>
              <p>
                Ayrine does not offer refunds once an order is confirmed or processed.
                Orders cannot be cancelled after dispatch and shipping charges are non-refundable.
              </p>
            </div>

            <div className="crAlert warn">
              <div className="crAlertTitle">Returned Parcel Rule</div>
              <p>
                If a parcel is returned due to incorrect address, unavailable customer,
                wrong phone number, or refusal to accept delivery,
                re-dispatch will require payment of shipping charges again.
              </p>
            </div>

            <div className="crChecklist">
              <div className="crCheckTitle">Before placing order, please ensure:</div>
              <div className="crCheckItem">✓ Correct full address</div>
              <div className="crCheckItem">✓ Active reachable phone number</div>
              <div className="crCheckItem">✓ Availability for delivery calls</div>
              <div className="crCheckItem">✓ Product details reviewed carefully</div>
            </div>
          </div>

          {/* RIGHT — ACCORDION */}
          <div className="crCard">
            <h2 className="crCardTitle">Detailed Policy</h2>

            <div className="crAccordion">

              <AccItem title="Shipping partner" icon="🚚" defaultOpen>
                <p>
                  All Ayrine orders are shipped through our trusted logistics partner,
                  <b> Delhivery</b>.
                </p>
                <p>
                  Delivery is handled by third-party logistics. Ayrine does not operate
                  its own delivery network.
                </p>
              </AccItem>

              <AccItem title="Delivery responsibility" icon="📦">
                <p>
                  Every order is carefully packed and verified before dispatch.
                </p>
                <p>After handover to the courier:</p>
                <ul className="crList">
                  <li>Delivery is managed by the logistics company</li>
                  <li>Delays due to courier, weather, or regional issues are beyond our control</li>
                  <li>Customers must track shipments regularly</li>
                </ul>
              </AccItem>

              <AccItem title="Address & contact requirements" icon="📌">
                <p>To avoid delivery issues, please ensure:</p>
                <ul className="crList">
                  <li>Correct and complete address</li>
                  <li>Active contact number</li>
                  <li>Availability during delivery attempts</li>
                </ul>
                <p>
                  Incorrect details may lead to return shipments and additional shipping charges.
                </p>
              </AccItem>

              <AccItem title="Delivery timelines" icon="⏱">
                <p>All Ayrine orders are shipped from Kerala.</p>
                <p>
                  Customers in North, West, or East India may occasionally experience
                  slightly longer delivery times depending on transit routes.
                </p>
              </AccItem>

              <AccItem title="Mandatory unboxing video policy" icon="🎥">
                <p>Required for complaints related to:</p>
                <ul className="crList">
                  <li>Damaged items</li>
                  <li>Missing products</li>
                  <li>Incorrect products</li>
                </ul>

                <div className="crVideoBox">
                  <div className="crVideoTitle">Video must:</div>
                  <div className="crCheckItem">✓ Start before opening parcel</div>
                  <div className="crCheckItem">✓ Show package 360° clearly</div>
                  <div className="crCheckItem">✓ Display shipping label</div>
                  <div className="crCheckItem">✓ Be continuous without cuts</div>
                </div>

                <p className="crMuted">
                  Complaints without a valid unboxing video will not be accepted.
                </p>
              </AccItem>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}